export const AlertType = {
    SUCCESS: "success",
    WARNING: "warning",
    DANGER: "danger",
    PRIMARY: "primary",
    SECONDARY: "secondary",
    LIGHT: "light",
    DARK: "dark"
};